import { useTranslation } from 'react-i18next'
import type { EvidenceSummary } from '../../../types/evidence-numbers'

interface SummaryCardProps {
  label: string
  value: number
  accent?: boolean
}

function SummaryCard({ label, value, accent }: SummaryCardProps): React.ReactElement {
  return (
    <div className="rounded-xl border border-[var(--card-border)] bg-[var(--bg-card)] px-4 py-3">
      <p className="text-xs font-[var(--font-mono)] font-medium tracking-wider text-[var(--text-dim)] uppercase">
        {label}
      </p>
      <p
        className={`mt-1 text-2xl font-semibold ${accent ? 'text-[var(--accent)]' : 'text-[var(--text)]'}`}
      >
        {value}
      </p>
    </div>
  )
}

interface EvidenceSummaryCardsProps {
  summary: EvidenceSummary | null
  loading: boolean
}

export function EvidenceSummaryCards({
  summary,
  loading,
}: EvidenceSummaryCardsProps): React.ReactElement {
  const { t } = useTranslation('evidence')

  if (loading || !summary) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7">
        {Array.from({ length: 7 }).map((_, idx) => (
          <div
            key={idx}
            className="h-20 animate-pulse rounded-xl border border-[var(--card-border)] bg-[var(--bg-card)]"
          />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7">
      <SummaryCard label={t('summary.totalBase')} value={summary.totalBase} accent />
      <SummaryCard label={t('summary.totalCollections')} value={summary.totalCollections} />
      <SummaryCard label={t('summary.virtual')} value={summary.virtualCount} />
      <SummaryCard label={t('summary.active')} value={summary.activeCount} />
      <SummaryCard label={t('summary.returned')} value={summary.dataReturnedCount} />
      <SummaryCard label={t('summary.ingested')} value={summary.dataIngestedCount} />
      <SummaryCard label={t('summary.exported')} value={summary.dataExportedCount} />
    </div>
  )
}
